<template>
  <app-layout>
    <div class="max-w-7xl mx-auto flex mb-12">
      <div class="w-full p-2 sm:px-6 lg:px-8">
        <div class="bg-white shadow-xl sm:rounded-lg p-4 sm:p-6 lg:p-8">
          <zapier-workflow
            :signUpEmail.prop="this.$page.props.auth.user.email"
            :signUpFirstName.prop="formattedName.first"
            :signUpLastName.prop="formattedName.last"
            :clientId.prop='"ohihh2SHEHP23k20f13XHgLtXUGvGacpy2a1sJCM"'
            :theme.prop='"light"'
            :introCopyDisplay.prop='"show"'
            :guessZapDisplay.prop='"show"'
          ></zapier-workflow>
        </div>
      </div>
    </div>
  </app-layout>
</template>

<script>
import AppLayout from "../../Layouts/AppLayout";
import {Head} from '@inertiajs/vue3';

export default {
  props: {
    tokens: {
      default: undefined,
    },
    csrf: {
      default: undefined,
    },
  },
  computed: {
    formattedName() {
      // since we don't actually ask for first + last name,
      // we're just going to be naive and split their name at the first
      // space and use everything before it as their first name and
      // everything after the space as their last name
      let name = this.$page.props.auth.user.name;
      let [firstName, ...lastName] = name.split(" ");
      lastName = lastName.join(" ");

      return {
        first: firstName === "" ? "Empty" : firstName,
        last: lastName === "" ? "Empty" : lastName
      }
    }
  },
  components: {
    AppLayout,
  },
  data() {
    return {};
  },
  methods: {},
};
</script>
